import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { TfService } from './tf-service.service';
import { User } from './model/tf-user';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(private router: Router, private tfService: TfService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // Use checkAuthStatus to get fresh authentication data
    const authInfo = await firstValueFrom(this.tfService.checkAuthStatus());

    // Check if user is authenticated
    if (!authInfo.isAuthenticated) {
      console.log('User not authenticated - redirecting to home');
      this.router.navigate(['/home'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    const userGroups = this.tfService.normalizeUserGroups(authInfo.userGroups);
    console.log('User groups:', userGroups);

    // Check permissions based on route
    if (userGroups.includes('admin') && state.url.startsWith('/customer')) {
      console.log('Admin attempting to access customer route - unauthorized');
      // this.router.navigateByUrl('/unauthorized');
      return false;
    }

    if (
      this.tfService.isCustomerPortalUser(userGroups) &&
      !userGroups.includes('admin') &&
      state.url.startsWith('/admin')
    ) {
      const allowedForAdminCustomer =
        userGroups.includes('adminCustomer') &&
        this.tfService.isAdminCustomerAllowedAdminUrl(state.url);
      if (!allowedForAdminCustomer) {
        console.log('Customer portal user attempting to access admin route - unauthorized');
        return false;
      }
    }

    console.log('Access granted for route:', state.url);
    return true;
  }

  public getUsersFromLocalCache(): User[] {
    return JSON.parse(localStorage.getItem('users') || '[]');
  }
}